// packages import
import { useContext } from "react";
import moment from "moment";
import { Box, Grid, Typography } from "@mui/material"
// component import
import { MfaSetting } from "../components/profile/MfaSetting";
import { PersonalSetting } from "../components/profile/PersonalSetting";
// others
import palette from "../theme/palette"
import { CardBox } from "../theme/styleComponents"
import { caseDetailGrid } from "../theme/styleConstants";
import { AuthContext } from "../context";
import { titleize } from "../utils";
import { NOT_APPLICABLE, STANDARD_DATE_FORMAT } from "../constants";

export const ProfileContainer = () => {
  const { currentUser } = useContext(AuthContext)
  const { createdAt, email, roles } = currentUser || {}
  const roleName = roles && roles[0]?.role
  const createdDate = createdAt && moment(parseInt(createdAt)).format(STANDARD_DATE_FORMAT)

  return (
    <Box maxWidth='820px' margin='auto' paddingTop='44px'>
      <PersonalSetting currentUser={currentUser} />

      <MfaSetting currentUser={currentUser} />

      {/* Change Password is hidden at the client's request: users may not change their own passwords. */}

      <CardBox mt={3}>
        <Box display="flex" alignItems="center" justifyContent="space-between" padding={3} borderBottom={`1px solid ${palette.lightGrayTwo}`}>
          <Typography variant="h6" fontSize="18px">Your Info</Typography>
        </Box>

        <Grid container sx={caseDetailGrid}>
          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-Title">Email</Typography>
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-SubTitle">{email || NOT_APPLICABLE}</Typography>
          </Grid>
        </Grid>

        <Grid container sx={caseDetailGrid}>
          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-Title">Role</Typography>
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-SubTitle">{titleize(roleName || '')}</Typography>
          </Grid>
        </Grid>

        <Grid container sx={caseDetailGrid}>
          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-Title">Joined On</Typography>
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h6" className="CaseDetail-SubTitle">{createdDate}</Typography>
          </Grid>
        </Grid>
      </CardBox>
    </Box>
  )
}